<script>
  import { TP, FP, TN, FN } from "./data-store.js";
</script>

<table>
  <tr>
    <th />
    <th class="table-head">Predicted: Has Cancer</th>
    <th class="table-head">Predicted: Healthy</th>
  </tr>
  <tr>
    <td class="table-head">Actually: Has Cancer</td>
    <td>Correct Cancer Predictions<br><small>(True Positive - TP): {$TP}</small></td>
    <td>Missed Cases<br><small>(False Negative - FN): {$FN}</small></td>
  </tr>
  <tr>
    <td class="table-head">Actually: Healthy</td>
    <td>False Alarms<br><small>(False Positive - FP): {$FP}</small></td>
    <td>Correct Healthy Predictions<br><small>(True Negative - TN): {$TN}</small></td>
  </tr>
</table>

<style>
  table {
    border-collapse: collapse;
    margin: auto;
    font-size: 18px;
    font-family: var(--font-main);
  }

  td,
  th {
    border: 3px solid #dddddd;
    text-align: left;
    padding: 8px;
    color: var(--squid-ink);
    line-height: 1.3;
  }

  small {
    color: #666;
    font-size: 0.8em;
    font-style: italic;
  }

  th:nth-child(1) {
    border: 0;
  }

  .table-head {
    font-family: var(--font-heavy);
    color: var(--squid-ink);
    border: none;
  }

  @media screen and (max-width: 768px) {
    table {
      max-width: 95%;
    }

    .table-head {
      font-size: 17px;
    }

    td,
    th {
      font-size: 17px;
    }
  }
</style>
